import { Row, Col, Card, Spinner } from 'react-bootstrap';

const STATS = [
  { key: 'total',     label: 'Total Users',  icon: 'bi-people-fill',       color: 'primary' },
  { key: 'active',    label: 'Active',       icon: 'bi-person-check-fill', color: 'success' },
  { key: 'pending',   label: 'Pending',      icon: 'bi-hourglass-split',   color: 'warning' },
  { key: 'suspended', label: 'Suspended',    icon: 'bi-person-x-fill',     color: 'danger'  },
];

function UserStatCards({ users, loading }) {
  const counts = {
    total:     users.pending.length + users.active.length + users.suspended.length,
    active:    users.active.length,
    pending:   users.pending.length,
    suspended: users.suspended.length,
  };

  return (
    <Row className="mb-4 g-3">
      {STATS.map(s => (
        <Col key={s.key} xs={6} lg={3}>
          <Card className="border-0 um-stat-card h-100">
            <Card.Body className="d-flex align-items-center gap-3 py-3">
              <div className={`um-stat-icon text-${s.color}`}>
                <i className={`bi ${s.icon}`}></i>
              </div>
              <div>
                <div className="fw-bold fs-4 lh-1">
                  {loading ? <Spinner animation="border" size="sm" /> : counts[s.key]}
                </div>
                <div className="small text-muted">{s.label}</div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default UserStatCards;
